import instanceQuery from 'graphql/queries/schedules/BusinessRuleParameterAttributeQuery.graphql';
import mutationQuery from 'graphql/mutations/schedules/BusinessRuleParameterAttributeMutation.graphql';
import fragment from 'graphql/fragments/schedules/BusinessRuleParameterAttributeFragment.graphql';
import listQuery from 'graphql/queries/schedules/BusinessRuleParameterAttributeListQuery.graphql';

const BusinessRuleParameterAttribute = {
  type: 'BusinessRuleParameterAttribute',
  title: 'Business Rule Parameter Attributes',
  formTitle: 'Business Rule Parameter Attributes',
  formUrl: '',
  workspaceUrl: '',
  instance: instanceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
    labelKey2: 'conditionType',
  },
  fragment,
};

export default BusinessRuleParameterAttribute;
